export const extendUrl = {
    url: process.env.REACT_APP_URL_FACTORY || (window.location.href.match(/^http:\/\/localhost/) ? 'http://localhost:3101' : 'https://f1-staging.merchize.com')
}
